__webpack_require__.p = "https://images-cdn-staging.curipod.com/d-49d61512/_next/";